<ng-container *ngIf="{ articleRefs: articleRefs$ | async, searchResults: searchResults$ | async } as data">
  <form [formGroup]="formGroup" class="mb-7">
    <label class="d-block mb-2">{{ 'common.search_heading' | cxTranslate }}</label>

    <py-search-field
      [group]="formGroup"
      [fieldName]="'text'"
      [placeholder]="'common.searchForArticles_placeholder' | cxTranslate"
      (handleReset)="onResetSearchForm()"
    ></py-search-field>
  </form>

  <div *ngIf="data.articleRefs?.length > 0; else noResults">
    <py-catalog-article-list
      [articleRefs]="data.articleRefs"
      [additionalArticleActions]="additionalArticleActions"
      [hideAddToShoppingListButton]="true"
      [useArticleCartTypeInsteadOfGivenToAddToCart]="true"
      [cartType]="cartType"
    ></py-catalog-article-list>
    <ng-container *ngIf="data.searchResults">
      <div
        class="pagination-wrapper mt-2 d-flex flex-column flex-xl-row align-items-center"
        *ngIf="data.searchResults.pagination?.totalResults"
      >
        <py-show-per-page [formGroup]="formGroup" [controlName]="'pageSize'" [basicOptionsMode]="true"></py-show-per-page>
        <py-load-more
          class="pt-7 pt-xl-4"
          [totalItemCount]="data.searchResults.pagination?.totalResults"
          [totalPageCount]="data.searchResults.pagination?.totalPages"
          [currentPageNumber]="data.searchResults.pagination?.currentPage"
          [itemCount]="data.searchResults?.articleRefs?.length || 0"
          (dispatch)="nextPage($event)"
          [totalItemCountName]="'article.typeName_hint' | cxTranslate : { count: data.searchResults?.pagination?.totalResults }"
        ></py-load-more>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #noResults>
  <py-no-results [description]="'myAssortment.noResults_hint' | cxTranslate"></py-no-results>
</ng-template>
